import { render } from "./DownloadIcon.vue?vue&type=template&id=c5b22c6c&ts=true"
import script from "./DownloadIcon.vue?vue&type=script&lang=ts"
export * from "./DownloadIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__